<template>
  <v-container fluid>
    <v-layout>
      <v-flex class="margin-custom-width-left">
        <v-flex xs12 sm10 md6>
          <v-form ref="form" v-model="valid">
            <label class="headline">Contact</label>
            <v-text-field
              prepend-icon="person"
              v-model="name"
              :rules="nameRules"
              label="Name"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="contact_mail"
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>
            <v-textarea
              prepend-icon="comment"
              v-model="comments"
              :rules="commentRule"
              label="Note"
              required
            ></v-textarea>

            <v-btn :disabled="!valid" @click="sendEmail()" color="primary">Send</v-btn>
            <v-btn @click="clear" color="info">Clear</v-btn>
            <br />
            <br />
          </v-form>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.visible"
      :color="'success'"
      :timeout="5000"
      multi-line
    >{{ snackbar.text }}</v-snackbar>
  </v-container>
</template>


<script>
import dataService from "@/data/data.service";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    snackbar: {
      text: "",
      visible: false
    },
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Name is required"
      //  v => (v && v.length <= 10) || "Name must be less than 10 characters"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    comments: null,
    commentRule: [v => !!v || "Comments required"]
  }),

  methods: {
    sendEmail() {
      if (this.$refs.form.validate()) {
        let env = process.env.NODE_ENV || "development";
        let config = require("../../config")[env];

        let emailObj = {
          from: "inquiry@fairfaxcityfutsal.com",
          to: config.email.recipient,
          subject: "Inquiry - Fairfax City Futsal",
          body:
            `From: ${this.name} (${this.email}) <br><br>` +
            `Comment: ${this.comments}`
        };
        dataService.modules.email.sendMail(emailObj).then(() => {
          this.valid = false;
          this.snackbar.text =
            "Thanks for your interest in Fairfax City Futsal. Your email is on its way!";
          this.snackbar.visible = true;
        });
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>